import EditPasswordModalView from "./editPasswordModal.html";
import AddAuthenticatorModalView from "./addAuthenticatorModal.html"; 


angular.module("users")

    .controller("UsersEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', 'gridService','$filter', 'logService', 'notificationService',
        function  (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, $uibModal, modalService, gridService, $filter, logService, notificationService) {
        let tests = [/\d/, /[a-z]/, /[A-Z]/, /[^A-Z-\d]/i];

        function test(pass){
            if(pass == null)
                return -1;
            let s = 0;
            if(pass.length < 8)
                return 0;
            for(let i in tests)
                if(tests[i].test(pass))
                    s++
            return s;
        }

        $scope.v = function() {
            let val = test($scope.user.password);
            if(!$scope.validPassword) {
                $scope.validPassword = val === 4;
            }
            return val;
        };



        //Comporbamos si el usuario conectado es de tipo "support"
        $scope.conected_user_id = LoginService.get("userId");
        Restangular.one('Users', $scope.conected_user_id).get().then(function (result) {

            if (result.type == "support") {
                $scope.selectTypes = [{ name: "staff" }, { name: "lite" }, {name: "support"}];
            } else {
                $scope.selectTypes = [{ name: "staff" }, { name: "lite" }];
            }
        });



        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("USERS_WRITE");
        $scope.validPassword = true;
        $scope.data = {
            uniqueName: ""
        };

        $rootScope.title = $filter('translate')('users.title');
        $scope.user = {
            FK_users_roles_users: [],
            FK_users_permissions_users: [],
            FK_asu_users: [],
            FK_users_images: {},
            active: true
        };

       
        $scope.userRolesIds = [];
        $scope.userPermissionsIds = [];
        $scope.userAuthenticationServicesIds = [];
        $scope.userCredentialsIds = [];
        $scope.showQR = false;

        Restangular.all('StaffPositions').getList().then(function (positions) {
            $scope.selectPositions = positions;
        });

        
        if ((angular.isUndefined($stateParams.id) || $stateParams.id == "") && $stateParams.id != "profile") {
            $scope.validPassword = false;

            $rootScope.breadcrumb = [
                { title: $filter('translate')('users.list'), url: "users.list" },
                { title: $filter('translate')('users.add') }
            ];

        }
        else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('users.list'), url: "users.list" },
                { title: $filter('translate')('users.edit') }
            ];
            
            let userId = $stateParams.id;
            if(userId === "profile") {
                userId = LoginService.get("userId");
                $scope.showQR = true;
            }
            
            $scope.allowAddCredentials = false;
            
            Restangular.one('Users', userId).get().then(function (results) {

                $scope.user = results;

                if ($scope.user.user_expired != null) {
                    $scope.user.user_expired = new Date($scope.user.user_expired);
                }

                $scope.user.password = "";
                $scope.password2 = $scope.user.password;
                if ($scope.user.FK_users_permissions_users == null) {
                    $scope.user.FK_users_permissions_users = [];
                } else {
                    $scope.gridOptionsPermissions.data = $scope.user.FK_users_permissions_users;
                    angular.forEach($scope.user.FK_users_permissions_users, function (userPermission) {
                        $scope.userPermissionsIds.push(userPermission.permission_id);
                    });
                }                

                if ($scope.user.FK_users_roles_users == null) {
                    $scope.user.FK_users_roles_users = [];
                } else {
                    $scope.gridOptionsRoles.data = $scope.user.FK_users_roles_users;



                    angular.forEach($scope.user.FK_users_roles_users, function (userRole) {
                        $scope.userRolesIds.push(userRole.role_id);

                        
                    });                    
                }

                if ($scope.user.FK_asu_users == null) {
                    $scope.user.FK_asu_users = [];
                } else {
                    $scope.gridOptionsAsu.data = $scope.user.FK_asu_users;
                    angular.forEach($scope.user.FK_asu_users, function (userAsu) {
                        $scope.userAuthenticationServicesIds.push(userAsu.authentication_service_id);
                    });
                }
                
                if($scope.user.WebauthnCredentials == null) {
                    $scope.user.WebauthnCredentials = [];
                } else {
                    $scope.gridOptionsCredentials.data = $scope.user.WebauthnCredentials;
                    angular.forEach($scope.user.WebauthnCredentials, function (userCredential) {
                        $scope.userCredentialsIds.push(userCredential.id);


                    });
                }
               
                //$scope.selectedLanguage.selected = $scope.user.languages;
                
                if($scope.conected_user_id == $scope.user.id && $scope.user.users_fk01.webauthn_enabled) {
                    $scope.allowAddCredentials = true;
                }
            });
        }

        //$scope.selectedLanguage = {};
        Restangular.all('Languages').getList({use_for_interface: true}).then(function (languages) {
            $scope.selectLanguages = languages;
        });

        // Available Groups

        Restangular.all('UsersGroups').getList().then(list => $scope.selectGroups = list);


        $scope.gridOptionsRoles = {
            enablePaginationControls: false,
            columnDefs: [
              { name: 'FK_users_roles_roles.id', visible: false, exporterSuppressExport: true },
              { name: 'FK_users_roles_roles.name', displayName: $filter('translate')('users.name') },
              {
                  name: ' ', width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('users.delete'), action: 'ng-click="grid.appScope.deleteRole(row.entity.FK_users_roles_roles.id);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ]

        };

        $scope.gridOptionsRoles.data = $scope.user.FK_users_roles_roles;

        $scope.gridOptionsCredentials = {
            enablePaginationControls: false,
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                { name: 'RegDate', displayName: $filter('translate')('general.date'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm:ss\'' },
                {
                    name: ' ', width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('users.delete'), action: 'ng-click="grid.appScope.deleteCredential(row.entity.id);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ]

        };

        $scope.gridOptionsCredentials.data = $scope.user.WebauthnCredentials;

        $scope.gridOptionsPermissions = {
            enablePaginationControls: false,
            columnDefs: [
              { name: 'FK_users_permissions_permissions.id', visible: false, exporterSuppressExport: true },
              { name: 'FK_users_permissions_permissions.name', displayName: $filter('translate')('users.name') },
              {
                  name: ' ', width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('users.delete'), action: 'ng-click="grid.appScope.deletePermission(row.entity.FK_users_permissions_permissions.id);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right"})
              },
            ]
        };

   

        $scope.gridOptionsPermissions.data = $scope.user.FK_users_permissions_users;

        $scope.gridOptionsAsu = {
            enablePaginationControls: false,
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                { name: 'FK_asu_authentication_services.name', displayName: $filter('translate')('users.name') },
                { name: 'unique_name', displayName: $filter('translate')('users.unique_name') },
                {
                    name: ' ', width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('users.delete'), action: 'ng-click="grid.appScope.deleteAuthenticationService(row.entity.FK_asu_authentication_services.id);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ]
        };

        $scope.gridOptionsAsu.data = $scope.user.FK_asu_users;


        
        Restangular.all('Roles').getList().then(function (roles) {
            $scope.selectRoles = roles;
        });
        $scope.selectRole = {};

        Restangular.all('Roles').getList().then(function (roles) {
            $scope.selectRoles = roles;
        });
        $scope.selectRole = {};

        Restangular.all('Permissions').getList().then(function (permissions) {
            $scope.selectPermissions = permissions;
        });
        $scope.selectPermission = {};


        Restangular.all('AuthenticationServices').getList().then(function (authenticationServices) {
            $scope.selectAuthenticationServices = authenticationServices;
        });
        $scope.selectAuthenticationService = {};


        Restangular.all('AuthenticationServicesUsers').getList().then(function (serviceUsers) {
            $scope.serviceUsers = serviceUsers;
        });
        $scope.serviceUsers = {};
        
        $scope.filterRoles = function (value) {
            if (angular.isDefined($scope.userRolesIds) && $scope.userRolesIds.indexOf(value.id) == -1) {
                return true;
            } else {
                return false;
            }
        }

        $scope.filterPermissions = function (value) {
            if (angular.isDefined($scope.userPermissionsIds) && $scope.userPermissionsIds.indexOf(value.id) == -1) {
                return true;
            } else {
                return false;
            }

        }

        $scope.filterAuthenticationServices = function (value) {
            if (angular.isDefined($scope.userAuthenticationServicesIds) && $scope.userAuthenticationServicesIds.indexOf(value.id) == -1) {
                return true;
            } else {
                return false;
            }

        }

        $scope.addRole = function () {
            if (!angular.isUndefined($scope.selectRole.selected) && $scope.selectRole.selected != "") {                
                var noExiste = true;                
                
                angular.forEach($scope.user.FK_users_roles_users, function (user_role) {
                    if (user_role.role_id == $scope.selectRole.selected.id) {
                        noExiste = false;
                    }
                });
                if (noExiste && !angular.isUndefined($scope.selectRole.selected)) {
                    var user_role = {
                        role_id: $scope.selectRole.selected.id,
                        FK_users_roles_roles: $scope.selectRole.selected,
                        user_id: $scope.user.id,
                        users: {
                            company_id: $scope.user.company_id,
                            id: $scope.user.id,
                            name: $scope.user.name,
                            username: $scope.user.username
                        }
                    };
                    $scope.user.FK_users_roles_users.push(user_role);                    
                    $scope.userRolesIds.push($scope.selectRole.selected.id);
                    // tentativa de actualizar la vista 
                    $scope.gridOptionsRoles.data = $scope.user.FK_users_roles_users;
                    if (!$scope.$$phase) $scope.$apply();
                }
                
            }
            $scope.selectRole.selected = "";
        }

        $scope.deleteCredential = function (id) {
            Restangular.one('Auth/WebAuthn/Credential/', id).remove().then(function (result) {
                var index = $scope.userCredentialsIds.indexOf(id);
                $scope.userCredentialsIds.splice(index, 1);
            });
        };
        
        $scope.deleteRole = function (id) {
            
            angular.forEach($scope.user.FK_users_roles_users, function (user_role, idx) {
                if (user_role.role_id == id) {
                    $scope.user.FK_users_roles_users.splice(idx, 1);

                }
            });
            var index = $scope.userRolesIds.indexOf(id);
            $scope.userRolesIds.splice(index, 1);
        }

        $scope.addPermission = function () {

            if (!angular.isUndefined($scope.selectPermission.selected) && $scope.selectPermission.selected != "") {
                var noExiste = true;                
                angular.forEach($scope.user.FK_users_permissions_users, function (user_permission) {
                    if (user_permission.permission_id == $scope.selectPermission.selected.id) {
                        noExiste = false;
                    }
                });
                if (noExiste && !angular.isUndefined($scope.selectPermission.selected)) {
                    var user_permission = {
                        permission_id: $scope.selectPermission.selected.id,
                        FK_users_permissions_permissions: $scope.selectPermission.selected,
                        user_id: $scope.user.id,
                        users: {
                            company_id: $scope.user.company_id,
                            id: $scope.user.id,
                            name: $scope.user.name,
                            username: $scope.user.username
                        }
                    };
                    $scope.user.FK_users_permissions_users.push(user_permission);
                    $scope.userPermissionsIds.push($scope.selectPermission.selected.id);
                    if (!$scope.$$phase) $scope.$apply();
                }
            }
            $scope.selectPermission.selected = "";
        }

        $scope.deletePermission = function (id) {
            
            angular.forEach($scope.user.FK_users_permissions_users, function (user_permission, idx) {
                if (user_permission.permission_id == id) {
                    $scope.user.FK_users_permissions_users.splice(idx, 1);
                }
            });
            var index = $scope.userPermissionsIds.indexOf(id);
            $scope.userPermissionsIds.splice(index, 1);
        }



        $scope.addAuthenticationService = function () {
            if (!angular.isUndefined($scope.selectAuthenticationService.selected) && $scope.selectAuthenticationService.selected != "") {
                var noExiste = true;
                angular.forEach($scope.user.FK_asu_users, function (user_authentication_service) {
                    if (user_authentication_service.authentication_service_id == $scope.selectAuthenticationService.selected.id) {
                        
                        noExiste = false;
                    }
                });
                angular.forEach($scope.serviceUsers, function (serviceUsers) {
                    if (serviceUsers.authentication_service_id == $scope.selectAuthenticationService.selected.id && serviceUsers.unique_name == $scope.data.uniqueName) {

                        uniqueNameWarning();
                        noExiste = false;
                    }
                });

                if (noExiste && !angular.isUndefined($scope.selectAuthenticationService.selected)) {
                    var user_authentication_service = {
                        authentication_service_id: $scope.selectAuthenticationService.selected.id,
                        FK_asu_authentication_services: $scope.selectAuthenticationService.selected,
                        user_id: $scope.user.id,
                        unique_name: $scope.data.uniqueName,
                        users: {
                            company_id: $scope.user.company_id,
                            id: $scope.user.id,
                            name: $scope.user.name,
                            username: $scope.user.username
                        }
                    };
                    $scope.user.FK_asu_users.push(user_authentication_service);
                    $scope.userAuthenticationServicesIds.push($scope.selectAuthenticationService.selected.id);
                    if (!$scope.$$phase) $scope.$apply();
                }
            }
            $scope.selectAuthenticationService.selected = "";
            $scope.data.uniqueName = "";

        }

        $scope.deleteAuthenticationService = function (id) {

            angular.forEach($scope.user.FK_asu_users, function (user_authentication_service, idx) {
                if (user_authentication_service.authentication_service_id == id) {
                    $scope.user.FK_asu_users.splice(idx, 1);
                }
            });
            var index = $scope.userAuthenticationServicesIds.indexOf(id);
            $scope.userAuthenticationServicesIds.splice(index, 1);
        }



       

        $scope.saveUser = function (frmUser) {
            if ($scope.user.user_expired != null) {
                $scope.user.user_expired = new Date($scope.user.user_expired);
            }

            if (angular.isDefined($scope.user.id)) {
                if (LoginService.get("userId") == $scope.user.id)
                    LoginService.set("userIcon", $scope.user.icon);
                delete $scope.user.FK_users_images;
                $scope.user.put().then(function (result) {                    
                    if (typeof (result.id) != "undefined") {
                        $state.go("users.list");
                        toastr.success($filter('translate')('users.user_modified'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('users').post($scope.user).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        $state.go("users.list");
                        toastr.success($filter('translate')('users.user_created'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.confirmClearAuthenticator = function () {
            modalService.confirm({
                title: 'Eliminar Authenticator',
                message: '¿Seguro que quieres eliminar el código de Authenticator de este usuario? Tendrás que guardar para confirmar el cambio.',
                onAccept: function () {
                    $scope.user.AuthenticatorSecret = null;
                }
            });
        };

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('users.delete'),
                message: $filter('translate')('users.delete_message')+" " + $scope.user.name + "?",
                onAccept: function () {
                    $scope.user.remove().then(function () {
                        $state.go("users.list");
                    });
                }
            });
        };

        //Aviso cuando el UniqueName está en uso
        let uniqueNameWarning = function () {
            modalService.message({
                title: $filter('translate')('users.unique_name_warning'),
                message: $filter('translate')('users.unique_name_warning_message') + " " + $scope.data.uniqueName + " " + $filter('translate')('users.unique_name_warning_message2'),
                onAccept: function () {}
            });
        };


        $scope.editPassword = function () {
            $scope.validPassword = false;
            let $modalInstance = $uibModal.open({
                animation: true,
                template: EditPasswordModalView,
                controller: "EditPasswordModalCtrl",
                resolve: {
                    user: function () {
                        return $scope.user;
                    }                  
                }

            });
            
        };
        
        $scope.addAuthenticator = function () {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddAuthenticatorModalView,
                controller: "AddAuthenticatorModalCtrl",
                resolve: {
                    user: function () {
                        return $scope.user;
                    }
                }

            });

        };

        let buildAuthenticatorRegistrationUrl = function (token) {
            return $state.href('authregisterauthcode', { token: token }, { absolute: true });
        };

        let getAuthenticatorRegistrationLink = function () {
            return Restangular.one('Users', $scope.user.id).customPOST({}, 'AuthenticatorRegistrationLink')
                .then(function (result) {
                    return buildAuthenticatorRegistrationUrl(result.token);
                });
        };

        $scope.copyAuthenticatorRegistrationLink = function () {
            getAuthenticatorRegistrationLink().then(function (url) {
                if (navigator.clipboard?.writeText) {
                    navigator.clipboard.writeText(url);
                }
                toastr.success('Enlace de registro copiado al portapapeles');
            });
        };

        $scope.sendAuthenticatorRegistrationLink = function () {
            if (!$scope.user.mail) {
                modalService.message({
                    title: 'Authenticator',
                    message: 'El usuario no tiene un correo configurado.',
                    onAccept: function () {}
                });
                return;
            }

            Restangular.one('Users', $scope.user.id).customPOST({}, 'SendAuthenticatorRegistrationMail')
                .then(function () {
                    toastr.success($filter('translate')('notifications.sending_mail_success'));
                });
        };

        let buildWebauthnRegistrationUrl = function (token) {
            return $state.href('authregisterwebauthn', { token: token }, { absolute: true });
        };

        let getWebauthnRegistrationLink = function () {
            return Restangular.one('Users', $scope.user.id).customPOST({}, 'WebauthnRegistrationLink')
                .then(function (result) {
                    return buildWebauthnRegistrationUrl(result.token);
                });
        };

        $scope.copyWebauthnRegistrationLink = function () {
            getWebauthnRegistrationLink().then(function (url) {
                if (navigator.clipboard?.writeText) {
                    navigator.clipboard.writeText(url).then(function () {
                        toastr.success('Enlace de registro WebAuthn copiado al portapapeles');
                    });
                } else {
                    modalService.message({
                        title: 'Enlace de registro WebAuthn',
                        message: url,
                        onAccept: function () {}
                    });
                }
            });
        };

        $scope.sendWebauthnRegistrationLink = function () {
            if (!$scope.user.mail) {
                modalService.message({
                    title: 'WebAuthn',
                    message: 'El usuario no tiene un correo configurado.',
                    onAccept: function () {}
                });
                return;
            }

            Restangular.one('Users', $scope.user.id).customPOST({}, 'SendWebauthnRegistrationMail')
                .then(function () {
                    toastr.success($filter('translate')('notifications.sending_mail_success'));
                })
                .catch(function () {
                    toastr.error($filter('translate')('notifications.sending_mail_error'));
                });
        };


        /*
         * Foto
         */

        $scope.addFile = function (flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                var uri = event.target.result;                
                $scope.$apply(function () {
                    $scope.user.icon = uri;
                    $scope.user.FK_users_images.image = uri;
                });
            };
            fileReader.readAsDataURL(flowFile.file);
        };
        
        let coerceToBase64Url = function (thing) {
            // Array or ArrayBuffer to Uint8Array
            if (Array.isArray(thing)) {
                thing = Uint8Array.from(thing);
            }

            if (thing instanceof ArrayBuffer) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to base64
            if (thing instanceof Uint8Array) {
                var str = "";
                var len = thing.byteLength;

                for (var i = 0; i < len; i++) {
                    str += String.fromCharCode(thing[i]);
                }
                thing = window.btoa(str);
            }

            if (typeof thing !== "string") {
                throw new Error("could not coerce to string");
            }

            // base64 to base64url
            // NOTE: "=" at the end of challenge is optional, strip it off here
            thing = thing.replace(/\+/g, "-")
                .replace(/\//g, "_")
                .replace(/={1,5}$/g, "");

            return thing;
        };
        
        let coerceToArrayBuffer = function (thing) {
            if (typeof thing === "string") {
                // base64url to base64
                thing = thing.replace(/-/g, "+").replace(/_/g, "/");

                // base64 to Uint8Array
                var str = window.atob(thing);
                var bytes = new Uint8Array(str.length);
                for (var i = 0; i < str.length; i++) {
                    bytes[i] = str.charCodeAt(i);
                }
                thing = bytes;
            }

            // Array to Uint8Array
            if (Array.isArray(thing)) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to ArrayBuffer
            if (thing instanceof Uint8Array) {
                thing = thing.buffer;
            }

            // error if none of the above worked
            if (!(thing instanceof ArrayBuffer)) {
                throw new TypeError("could not coerce to ArrayBuffer");
            }

            return thing;
        };
        
        let registerNewCredential = function (newCredential) {
            // Move data into Arrays incase it is super long
            let attestationObject = new Uint8Array(newCredential.response.attestationObject);
            let clientDataJSON = new Uint8Array(newCredential.response.clientDataJSON);
            let rawId = new Uint8Array(newCredential.rawId);

            const data = {
                id: newCredential.id,
                rawId: coerceToBase64Url(rawId),
                type: newCredential.type,
                extensions: newCredential.getClientExtensionResults(),
                response: {
                    attestationObject: coerceToBase64Url(attestationObject),
                    clientDataJSON: coerceToBase64Url(clientDataJSON)
                }
            };

            Restangular.all('Auth').customPOST(JSON.stringify(data), 'WebAuthn/MakeCredential/', null, {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }).then(function (response) {
                
                // show error
                if (response.status !== "ok") {
                    logService.error("Error creating credential");
                    logService.error(response.errorMessage);
                    return;
                }
            });
        }
        
        $scope.addCredentials = function () {
            Restangular.all("Auth").customPOST(null, "WebAuthn/MakeCredentialOptions/", null).then(function (makeCredentialOptions) {
                if(makeCredentialOptions.status === "ok") {
                    // Turn the challenge back into the accepted format of padded base64
                    makeCredentialOptions.challenge = coerceToArrayBuffer(makeCredentialOptions.challenge);
                    // Turn ID into a UInt8Array Buffer for some reason
                    makeCredentialOptions.user.id = coerceToArrayBuffer(makeCredentialOptions.user.id);

                    makeCredentialOptions.excludeCredentials = makeCredentialOptions.excludeCredentials.map((c) => {
                        c.id = coerceToArrayBuffer(c.id);
                        return c;
                    });

                    if (makeCredentialOptions.authenticatorSelection.authenticatorAttachment === null) makeCredentialOptions.authenticatorSelection.authenticatorAttachment = undefined;

                    logService.debug("Creating PublicKeyCredential...");

                    let newCredential;
                    try {
                        navigator.credentials.create({
                            publicKey: makeCredentialOptions
                        }).then(function (newCredential) {
                            logService.debug("PublicKeyCredential Created", newCredential);
                            registerNewCredential(newCredential);
                        });
                    } catch (e) {
                        let msg = "Could not create credentials in browser. Probably because the username is already registered with your authenticator. Please change username or authenticator."
                        console.error(msg, e);
                    }
                }
            });
        };
        
    }])

.controller("EditPasswordModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'user','modalService','$filter', function ($scope, $uibModalInstance, Restangular, user, modalService, $filter) {
    let tests = [/\d/, /[a-z]/, /[A-Z]/, /[^A-Z-\d]/i];

    function test(pass){
        if(pass == null)
            return -1;
        let s = 0;
        if(pass.length < 8)
            return 0;
        for(let i in tests)
            if(tests[i].test(pass))
                s++
        return s;
    }
    
    $scope.user = user;
    $scope.password = "";
    $scope.validPassword = false;

    $scope.v = function(){
        let val = test($scope.password);
        $scope.validPassword = val === 4;
        return val;
    };
    
    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.savePassword = function () {        
        if ($scope.password !== "") {

            $scope.user.password = $scope.password;
            $scope.user.put().then(function (result) {                
                if (typeof (result.id) != "undefined") {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('users.password_updated'));
                } else {
                    $scope.errorMessage = result.message;
                }
            });
        }
        
        

    };

}])
.controller("AddAuthenticatorModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'user','modalService','$filter', 'logService', function ($scope, $uibModalInstance, Restangular, user, modalService, $filter, logService) {
    $scope.qrCode = '';
    $scope.code = '';

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    
    $scope.saveAuthenticator = function () {
        Restangular.all("Auth").customPOST(null, "Authenticator/Verify/" + $scope.code, null).then(function (result) {
            logService.debug(result);
        });
    };
    
    Restangular.one('Auth/AuthenticatorQRCode').get().then(function (result) {
        $scope.qrCode = result;
    });
}]);